class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.lastScrollY = 0;
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener(
      'keyup',
      (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
    );
    this.summaryToggle.addEventListener(
      'click',
      this.onSummaryClick.bind(this)
    );
    this.querySelector('button[type="button"]').addEventListener(
      'click',
      this.close.bind(this)
    );

    this.querySelector("form").addEventListener("submit", this.onsubmit.bind(this))
    this.summaryToggle.setAttribute('role', 'button');

    this.toggleKlevuSearch();
    // add scroll event listener to the window
    window.addEventListener('scroll', this.onWindowScroll.bind(this));
  }

 

  onWindowScroll(event) {
    this.lastScrollY = window.scrollY;
    const isScrollingDown = window.scrollY > this.lastScrollY;
    let klevuContainer = document.querySelector('.kuQuickSearchResultsContainer');

    // check if it's a mobile device
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    if (window.scrollY <= 100  && !isScrollingDown && isMobile) {
      if (!this.isOpen() && !this.isKuMobileDeviceEnabledHidden() && klevuContainer != null ) {
        this.open(event);
      }
    }
  }

  isKuMobileDeviceEnabledHidden() {
    const el = document.querySelector('.kuQuickSearchResultsContainer');
    if (!el) {
      // element with class .kuMobileDeviceEnabled not found
      return false;
    }
    const displayStyle = el.style.display;
    if (displayStyle === 'none') {
      // element is hidden with inline style
      return true;
    }
    // element is visible or hidden with CSS rules
    const computedStyle = window.getComputedStyle(el);
    return computedStyle.display === 'none';

  }
  
  onsubmit() {
    window.sessionStorage.removeItem("serp_cache");
    window.sessionStorage.removeItem("serp_offsetTop");
    window.sessionStorage.removeItem("last_product_clicked_url");
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    if(event.target.closest('details').hasAttribute('open')) {
      this.close();
    } else {
      this.open(event);

      // Show klevu search layout after half second
      setTimeout(function() {
        if(document.querySelector(".kuQuickSearchAutoCompleteLayout")) {
          document.querySelector(".kuQuickSearchAutoCompleteLayout").removeAttribute("style");
        }
      }, 500);
    }
  }

  waitForElm(selector) {
    return new Promise(resolve => {
      if (document.querySelector(selector)) {
        return resolve(document.querySelector(selector));
      }
      const observer = new MutationObserver(mutations => {
        if (document.querySelector(selector)) {
          resolve(document.querySelector(selector));
          observer.disconnect();
        }
      });
      observer.observe(document.body, {
          childList: true,
          subtree: true
      });
    });
  }

  outsideClick(event, notelem)	{
    
    let clickedOut = true, i, len = notelem.length;
    for (i = 0;i < len;i++)  {
        if (event.target == notelem[i] || notelem[i].contains(event.target)) {
            clickedOut = false;
        }
    }
    if (clickedOut) return true;
    else return false;
  }

  toggleKlevuSearch() {
    this.waitForElm('.klevuQuickSearchingArea').then((element) => {
      window.addEventListener('click', (event) =>  {
        if(element && !element.contains(event.target)) {
          if(element) {
            this.close(false);
            element = null;
          }  
        }  
      })
    })
  }

  open(event) {
    this.detailsContainer.setAttribute('open', true);
    document.body.classList.add('overflow-hidden');
    
    const searchInput = this.detailsContainer.querySelector('input:not([type="hidden"])');
    
    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      searchInput
    );
    
    // Ensure the search input gets focused after the modal is visible
    if (searchInput) {
      setTimeout(() => {
        searchInput.focus();
      }, 50);
    }
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.classList.remove('overflow-hidden');
    
    // Hide Klevu search results when closing modal
    const klevuLayout = document.querySelector(".kuQuickSearchAutoCompleteLayout");
    if (klevuLayout) {
      klevuLayout.style.display = 'none';
    }
  }
}

customElements.define('details-modal', DetailsModal);
